<template>
  <div class="row offer-filter pad-top">
    <div class="col-md-12">
      <MultiSelect track-by="login" v-model="Storage.webSelectedFilter" :options="Storage.webFilter" :multiple="true"
               :hide-selected="false" :preserve-search="true"
               :placeholder="$t('filter.webmaster_grid')" label="login" :searchable="true"
               :disabled="disabled" @input="dispatchInputAction" ref="multiselect">
        <template slot="option" scope="props">
          <div class="option__desc">
            <span class="option__title">
             {{ props.option.login }}
            </span>
          </div>
        </template>
      </MultiSelect>
    </div>
  </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import Storage from '../../api/Storage'
  import cSwitch from '../Switch'
  import API from '../../api/API'
  import { find } from 'lodash'
  import Helper from '../../api/Helper'

export default {
    name: 'ByWmFilter',
    components: {
      cSwitch,
      MultiSelect
    },
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    mounted () {
      this.$root.$on('country_selected', () => {
        API.getWebmasters(Helper.getCountryList()).then(response => {
          Storage.webFilter = response.data
        })
      })
      this.$root.$on('filters_reset_all', () => {
        this.reset()
      })
      this.$refs.multiselect.$on('select', function () {
        this.search = ''
      })
    },
    data () {
      return {
        Storage: Storage
      }
    },
    methods: {
      dispatchInputAction () {
        this.$root.$emit('country_selected')
      }
    },
    beforeDestroy () {
      this.$root.$off('country_selected')
    }
  }
</script>

<style>
.pad-top{
  padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// ByWmFilter.vue?45207698